const NBSP = " ";

const TABLE_ROW = /^\s*\|/;
const DIGIT_GROUP = /(\d) (?=\d{3}(?!\d))/g;
const AMOUNT_UNIT = /(\d) (?=(?:kr|NOK|MNOK|%|mill\.?)(?![\p{L}\d]))/gu;
const WRITTEN_DATE = /(\d{1,2}\.) (\p{L}{3,9}\.?) (\d{4})/gu;

export const withUnbreakableFigures = (markdown: string): string =>
  markdown
    .split("\n")
    .map((line) => (TABLE_ROW.test(line) ? unbreakable(line) : line))
    .join("\n");

const unbreakable = (row: string): string =>
  row
    .replace(DIGIT_GROUP, `$1${NBSP}`)
    .replace(AMOUNT_UNIT, `$1${NBSP}`)
    .replace(WRITTEN_DATE, `$1${NBSP}$2${NBSP}$3`);
